export default "__VITE_ASSET__MI4OFPa8__"